import {
    CUSTOMERFOCUS_DISPLAY_FILTER,
    CUSTOMERFOCUS_YEAR_FILTER,
    CUSTOMERFOCUS_QTR_FILTER,
    CUSTOMERFOCUS_MONTH_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_DISPLAY_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_ITEMGROUP_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_PRODUCTGROUP_FILTER,
    CUSTOMERFOCUS_PRODUCTORDER_PRODUCTLINE_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_DISPLAY_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_AMOUNT_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_ITEMGROUP_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_PRODUCTGROUP_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_PRODUCTLINE_FILTER,
    CUSTOMERFOCUS_SALESHISTORY_PRODUCTTYPE_FILTER,
    CUSTOMERFOCUS_SEARCH_TRIGGER
} from '../constants/ActionTypes';

const initialState = {
    displaySelected: {value: "MTD", label: "เดือน"},
    yearSelected: [],
    qtrSelected: [],
    monthSelected: [],
    displayProductOrderSelected: {value:"itemgroup", label: "หมวดสินค้า"},
    itemGroupProductOrderSelected: [],
    productGroupProductOrderSelected: [],
    productLineProductOrderSelected: [],
    displaySalesHistorySelected: {value:"itemgroup", label: "หมวดสินค้า"},
    amountSalesHistorySelected: { value: 'amount', label: 'ยอดขาย' },
    itemGroupSalesHistorySelected: [],
    productGroupSalesHistorySelected: [],
    productLineSalesHistorySelected: [],
    productTypeSalesHistorySelected: [],
    searchTrigger: 1  // เริ่มต้นที่ 1 เพื่อดึงข้อมูลครั้งแรก
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CUSTOMERFOCUS_DISPLAY_FILTER:
            return {
                ...state,
                displaySelected: action.payload
            }
        case CUSTOMERFOCUS_YEAR_FILTER:
                return {
                ...state,
                yearSelected: action.payload
                }
        case CUSTOMERFOCUS_QTR_FILTER:
            return {
                ...state,
                qtrSelected: action.payload
            }
        case CUSTOMERFOCUS_MONTH_FILTER:
            return {
                ...state,
                monthSelected: action.payload
            }
        case CUSTOMERFOCUS_PRODUCTORDER_DISPLAY_FILTER:
            return {
                ...state,
                displayProductOrderSelected: action.payload
            }
        case CUSTOMERFOCUS_PRODUCTORDER_ITEMGROUP_FILTER:
            return {
                ...state,
                itemGroupProductOrderSelected: action.payload
            }
        case CUSTOMERFOCUS_PRODUCTORDER_PRODUCTGROUP_FILTER:
            return {
                ...state,
                productGroupProductOrderSelected: action.payload
            }
        case CUSTOMERFOCUS_PRODUCTORDER_PRODUCTLINE_FILTER:
            return {
                ...state,
                productLineProductOrderSelected: action.payload
            }
        case CUSTOMERFOCUS_SALESHISTORY_DISPLAY_FILTER:
            return {
                ...state,
                displaySalesHistorySelected: action.payload
            }
        case CUSTOMERFOCUS_SALESHISTORY_AMOUNT_FILTER:
            return {
                ...state,
                amountSalesHistorySelected: action.payload
            }
        case CUSTOMERFOCUS_SALESHISTORY_ITEMGROUP_FILTER:
            return {
                ...state,
                itemGroupSalesHistorySelected: action.payload
            }
        case CUSTOMERFOCUS_SALESHISTORY_PRODUCTGROUP_FILTER:
            return {
                ...state,
                productGroupSalesHistorySelected: action.payload
            }
        case CUSTOMERFOCUS_SALESHISTORY_PRODUCTLINE_FILTER:
            return {
                ...state,
                productLineSalesHistorySelected: action.payload
            }
        case CUSTOMERFOCUS_SALESHISTORY_PRODUCTTYPE_FILTER:
            return {
                ...state,
                productTypeSalesHistorySelected: action.payload
            }
        case CUSTOMERFOCUS_SEARCH_TRIGGER:
            return {
                ...state,
                searchTrigger: action.payload
            }
        default:
            return state;
    }
}